import { render } from "./resultlistboard.vue?vue&type=template&id=4a898c70&scoped=true"
import script from "./resultlistboard.vue?vue&type=script&lang=js"
export * from "./resultlistboard.vue?vue&type=script&lang=js"

import "./resultlistboard.vue?vue&type=style&index=0&id=4a898c70&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a898c70"]])

export default __exports__